import {initTrustbars} from "../../../default/global/js/trustbar";
import {getChildrenClassForNestedItems} from "../../../default/global/js/nav";
import {closeFilterBox, initFilter} from "../../../default/global/js/filter";
import {initActionClicks, initFormSubmitChanges, initFormSubmitClicks} from "../../../default/global/js/actionClick";
import {focusInputGroups} from "../../../default/global/js/checkInputGroups";
import {initStickyHeaderHeightVar, initStickyState} from "../../../default/global/js/utilities/sticky";
import {triggerFavoritesBtns} from "../../../default/global/js/favorites";
import hoverintent from "../../../default/global/js/hoverintent";
import {initSlideshows} from "../../../default/global/js/slideshow";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {buildMobileMenu, hideMobileMenu, showMobileMenu} from "../../../default/global/js/mobilemenu";
import {excludeModal, triggerConfirmModalLink, triggerModal}  from "../../../default/global/js/modal";
import {initToggleSlide} from "../../../default/global/js/toggle";
import {initItemlistSlider} from "../../../ibc-global/js/itemListSlider";
import {initContentRegister} from "../../../ibc-global/js/contentRegister";
import {initBannerSlider} from "../../../ibc-global/js/bannerSlider";
import {initCountUp} from "../../../ibc-global/js/countUp";
import {initCardsYoutube} from "../../../ibc-global/js/cardsYoutube";
import {initItemcardNavigation} from "../../../ibc-global/js/itemcardNavigation";
import {initItemDocumentsRowClick} from "../../../ibc-global/js/itemDocuments";
import {initScrollbars} from "../../../default/global/js/scrollbar";
import {isTouchDevice} from "../../../default/global/js/touchDevice";
import {
    hideAllCustomSelect,
    hideCustomSelect,
    initCustomSelects,
    updateCustomSelectRangeFilterAction
} from "../../../default/global/js/customSelect";
import {initJumpmarks} from "../../../default/global/js/jumpmark";
import {initSearchItems} from "../../../default/global/js/searchItems";
import {initItemlistToggle} from "../../../default/global/js/itemlistToggle";
import {lottieLoader} from "../../../default/global/js/lottieLoader";
import {initFlashmessages} from "../../../default/global/js/flashmessages";
import {initPasswordFields} from "../../../default/global/js/password";
import {trimInputValues} from "../../../default/global/js/formValidator";
import {initSlidecontents} from "../../../default/global/js/slidecontent";
import {initPhoneCountryFields} from "../../../ibc-global/js/phoneCountryField";
import {initInputBody} from "../../../default/global/js/inputfile";
import {initImageGallery} from "../../../default/global/js/imageGallery";
import {initAjaxCollectionFilter} from "../../../default/global/js/ajaxCollectionFilter";
import {initDatepicker} from "../../../default/global/js/datepicker";
import {initLiveSearch} from "../../../default/global/js/liveSearch";
import {initContentTabs} from "../../../default/global/js/contentTabs";
import {initHistorySlider} from "../../../default/global/js/history";
import {initUploadInputBody} from "../../../default/global/js/uploadInputBody";
import {initScrollActivate} from "../../../default/global/js/scrollactivate";
import {loadPrices} from "../../../default/global/js/loadPrices";
import {initRangeslider} from "../../../default/global/js/rangeSlider";
import {initFlyout} from "../../../default/global/js/flyoutMenu";
import {maxHeightContent} from "../../../default/global/js/maxHeightContent";
import {initAjaxFormApi} from "../../../default/global/js/ajaxFormApi";
import {langSwitchByHrefLang} from "../../../default/global/js/langSwitchByHrefLang";
import {initContextMenu} from "../../../default/global/js/contextMenu";
import {initHighlightEditors} from "../../../default/global/ts/highlightEditor";
import {initRecaptchaForms} from "../../../default/global/js/recaptchaForm";
import {initBrandScrollbar} from "../../../ibc-global/js/brandScrollbar";

window.addEventListener("load", (event) => {
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");
    const IsTouchDevice = isTouchDevice();
    const stickyHeaderArea = document.querySelector('.headerMain');

    let breakPointSM = 1024;
    let sendFavoriteByJS = false;

    if (typeof GLOBALS!== "undefined") {
        breakPointSM = GLOBALS.gridBreakpoints.sm;
        sendFavoriteByJS = GLOBALS.sendFavoriteByJS;
    }

    if (mobileMenu && mobileMenuToggle && overlay) {
        const mobileMenuClose = mobileMenu.querySelector(".mobileMenu__close");

        buildMobileMenu(mobileMenu);

        mobileMenuToggle.addEventListener("click", function () {
            showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        mobileMenuClose.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        overlay.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            for (const filterbox of document.querySelectorAll('.filterBox')) {
                closeFilterBox(filterbox);
            }
        });
    }

    initTrustbars();

    initFilter();

    initActionClicks();

    initFormSubmitClicks();

    initFormSubmitChanges();

    focusInputGroups();

    trimInputValues();

    initInputBody();

    initPasswordFields();

    initPhoneCountryFields();

    initStickyHeaderHeightVar(stickyHeaderArea);

    for (const stickyElement of document.querySelectorAll('.js-sticky')) {
        initStickyState(stickyElement);
    }

    if (window.outerWidth < breakPointSM) {
        for (const parent of document.querySelectorAll('.navgroup > ul > li')) {
            getChildrenClassForNestedItems(parent);
        }
    }

    if (sendFavoriteByJS) {
        triggerFavoritesBtns();
    }

    triggerModal();
    excludeModal();
    triggerConfirmModalLink();

    initToggleSlide();

    initFlashmessages();

    if (!IsTouchDevice) {
        for (const el of document.querySelectorAll('.itembox,.iconbarItem')) {
            hoverintent(el);
        }
    }
    for (const el of document.querySelectorAll('.js-mainNavigation li')) {
        hoverintent(el);
    }

    initImageGallery();

    initSlideshows();

    initScrollbars();

    initSlidecontents();
    initContentRegister();
    initCardsYoutube();
    initCountUp();
    initBannerSlider();

    initItemlistSlider(document.querySelectorAll('.itemboxList.swiper'),{
        breakpointItems: {
            xs: 1.15,
            sm: 2.2,
            md: 2.2,
            lg: 3,
            xlg: 4
        }
    });

    initCustomSelects();

    // Tooltip, when necessary
    // import {Tooltip} from "../../../default/global/js/tooltip-custom";

    //var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
    //var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //    return new Tooltip(tooltipTriggerEl);
    //});

    initSearchItems(document.querySelectorAll('.js-searchInput'));

    let offsetTopJumpmarks = 0;
    if (stickyHeaderArea) {
        offsetTopJumpmarks = stickyHeaderArea.clientHeight;
    }

    if (typeof GLOBALS!== "undefined") {
        if(GLOBALS.offsetTopJumpmarks){
            offsetTopJumpmarks += GLOBALS.offsetTopJumpmarks;
        }
    }

    initJumpmarks(offsetTopJumpmarks);
    initItemcardNavigation();
    initItemDocumentsRowClick();

    let iopenGallery =  0;
    for (const item of document.querySelectorAll(".js-openGallery")) {
        if(!item.dataset.index){
            item.setAttribute("data-index",iopenGallery);
        }
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item);
        });
        iopenGallery++;
    }

    for (const pinBox of document.querySelectorAll(".js-stickyBox")) {
        initStickyState(pinBox);
    }
    lottieLoader();

    initItemlistToggle();

    initAjaxCollectionFilter();

    initAjaxFormApi();

    initDatepicker();

    initLiveSearch();

    initHistorySlider();

    initContentTabs();

    initBrandScrollbar();

    initRangeslider(document,function (e){
        if(e.slider.closest(".js-customSelect")){
            updateCustomSelectRangeFilterAction(e.slider.closest(".js-customSelect"),e.value);
        }
    });

    initRecaptchaForms();

    initHighlightEditors();

    maxHeightContent();
    langSwitchByHrefLang();

    initContextMenu();

    window.main = {
        hideAllCustomSelect: function (){
            hideAllCustomSelect();
        },
        hideCustomSelect: function (select){
            hideCustomSelect(select);
        }
    };
});